import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirstAnimationComponent } from './first-animation/first-animation.component';
//  import { SecondBannerComponent } from './second-banner/second-banner.component';
import { ThirdNavbarComponent } from './third-navbar/third-navbar.component';

import { FlucelFifthComponent } from './flucel-fifth/flucel-fifth.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { FlucelvaxBannerComponent } from './flucelvax-banner/flucelvax-banner.component';
import { RouterModule } from '@angular/router';
import { MediaModule } from '@spartacus/storefront';
import { FluadVideoComponent } from './fluad-video/fluad-video.component';
import { CustomEnhancedVaccineComponent } from './custom-enhanced-vaccine/custom-enhanced-vaccine.component';
@NgModule({
  declarations: [
    FirstAnimationComponent,
    // SecondBannerComponent,
    ThirdNavbarComponent,  
    FlucelFifthComponent,
    FlucelvaxBannerComponent,
    FluadVideoComponent,
    CustomEnhancedVaccineComponent,
    // SixthChoosecompComponent,
   
  
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents:{
        ProductsKeyFeaturesResource:{
        component:FirstAnimationComponent
      },
      SeqirusProductVideoBannerComponent:{
      component:FluadVideoComponent
      },
      SeqirusProductTimeEliminateComponent:{
      component:ThirdNavbarComponent
    },
    SeqirusFlucelvaxVaccineSubBannerComponent:{
      component:FlucelvaxBannerComponent

    },
    SeqirusProductSubPageComponent:{
      component:FlucelFifthComponent
    },
    SeqirusAllProductPageNewComponent:{
      component:CustomEnhancedVaccineComponent
    }
 
  }
    }as CmsConfig),
  
  ]
})
export class FlucelvaxModule { }